import { instance as axios } from "../index";

/**
 * 获取用户需要同意的协议列表
 * @param {Object} params - 查询参数
 * @param {string} params.channel - 渠道：applet.小程序,consultation.问诊系统,gather.设备采集端
 * @param {string} params.customerPhone - 客户手机号（可选）
 * @param {string} params.dataSource - 数据源（可选）
 * @returns {Promise} API响应
 */
export function getAgreementList(params) {
  return axios.get("/base-data/agreement/list", { params }).then((res) => res);
}

/**
 * 用户同意协议
 * @param {Object} params - 请求参数
 * @param {Array} params.agreements - 协议ID数组
 * @param {string} params.channel - 渠道：applet.小程序,consultation.问诊系统,gather.设备采集端
 * @param {string} params.customerPhone - 诊所手机号（可选）
 * @param {string} params.dataSource - 数据源（可选）
 * @returns {Promise} API响应
 */
export function agreeAgreements(params) {
  return axios.post("/base-data/agreement/agree", params).then((res) => res);
}